import React, { useState } from "react";
import overlayFactory from "react-bootstrap-table2-overlay";
import BootstrapTable from "react-bootstrap-table-next";
import { Modal, } from "react-bootstrap";


import PDFExport from "../../../../../helper/export-pdf";
import ExcelExport from "../../../../../helper/export-xlsx"
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
    Legend,
    Label,
    LabelList,

} from "recharts";
import moment from "moment";
const renderCustomizedLabel = (props) => {
    const { content, value, ...rest } = props;
    return <Label value={value + "%"}{...rest} fontSize="10" fill={value < 2 ? "#000" : "#FFF"} fontWeight="Bold" />;
};
export function priceFormatter(column) {
    return (
        <h6><strong>{Number((column.footer || 0).toFixed(2))}%</strong></h6>
    );
}
const addCommas = function (input) {
    // If the regex doesn't match, `replace` returns the string unmodified
    return (input.toString()).replace(
        // Each parentheses group (or 'capture') in this regex becomes an argument 
        // to the function; in this case, every argument after 'match'
        /^([-+]?)(0?)(\d+)(.?)(\d+)$/g, function (match, sign, zeros, before, decimal, after) {

            // Less obtrusive than adding 'reverse' method on all strings
            var reverseString = function (string) { return string.split('').reverse().join(''); };

            // Insert commas every three characters from the right
            var insertCommas = function (string) {

                // Reverse, because it's easier to do things from the left
                var reversed = reverseString(string);

                // Add commas every three characters
                var reversedWithCommas = reversed.match(/.{1,3}/g).join(',');

                // Reverse again (back to normal)
                return reverseString(reversedWithCommas);
            };

            // If there was no decimal, the last capture grabs the final digit, so
            // we have to put it back together with the 'before' substring
            return sign + (decimal ? insertCommas(before) + decimal + after : insertCommas(before + after));
        }
    );
};
export function unitsFormatter(column) {
    return (
        <h6><strong>{addCommas(Number(column.footer ?? 0).toFixed(0))}</strong></h6>
    );
}
export function ExecutiveSummary({ raw, mainTask, target, onHide, show }) {



    const _pos_resume = []
    const _raw_base = [...raw].filter((row) => row.yesno === "YES" || row.yesno === "NO")
    const pos_options = [...new Set(_raw_base.map(row => row.pos))]
    pos_options.forEach((pos) => {
        const results = _raw_base.filter((row) => row.pos === pos)
        const yes = results.filter(row => row.yesno === "YES")
        const no = results.filter(row => row.yesno === "NO")
        const percent_no = Number(((no.length / results.length) * 100).toFixed(2))
        const percent_yes = Number(((yes.length / results.length) * 100).toFixed(2))

        const document = {
            pos: pos,
            no: no.length,
            yes: yes.length,
            total: results.length,
            percent_no: Number(percent_no.toFixed(2)) + "%",
            percent_yes: Number(percent_yes.toFixed(2)) + "%"

        }
        _pos_resume.push(document)

    })

    const yes = _raw_base.filter(row => row.yesno === "YES")
    const no = _raw_base.filter(row => row.yesno === "NO")
    const _target = yes.length + no.length
    const effycency = Number((((_raw_base.length) / (target || 1)) * 100).toFixed(2))
    function getPercent(value, max) {
        return Number(((value / (max || 1)) * 100).toFixed(2))
    }
    const data = [
        {
            name: "r",
            "YES %": getPercent(yes.length, _target),
            "NO %": getPercent(no.length, _target),
        },
    ];
    return (
        <>

            <Modal show={show}
                size="lg"
                closeButton
                dialogClassName="modal-90w"
            >
                <Modal.Header onHide={onHide} closeButton>
                    <div className="row d-flex w-100 justify-content-between">
                        <div className="col-10">
                            <h1>Detalle, {mainTask}</h1>
                        </div>
                        <div className="col">
                            <div className="d-flex w-100 justify-content-end">
                                <span className="d-inline pointer-hover" onClick={() => {
                                    onHide(false)
                                }}>
                                    <i class="fas fa-times fa-2x" style={{ color: "#000" }}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <ResponsiveContainer height={100} width={"100%"}>
                        <BarChart

                            layout="vertical"
                            data={data}
                            margin={{ left: 0, right: 10 }}
                            stackOffset="expand"
                            className="pointer-hover"
                            onMouseEnter={() => {
                                document.body.style.cursor = 'pointer';

                            }}
                            onMouseLeave={() => {
                                document.body.style.cursor = 'default';

                            }}
                        >
                            <XAxis hide type="number" />
                            <YAxis
                                type="category"
                                dataKey="name"
                                stroke="#FFFFFF"
                                fontSize="12"
                            />
                            <Legend wrapperStyle={{ color: "#000" }} fill="#000" />
                            <Bar dataKey="YES %" fill="#8330C0" stackId="a">
                                <LabelList
                                    dataKey="YES %"
                                    position="center"
                                    content={renderCustomizedLabel}
                                />
                            </Bar>
                            <Bar dataKey="NO %" fill="#AE46F2" stackId="a">
                                <LabelList
                                    dataKey="NO %"
                                    position="center"
                                    content={renderCustomizedLabel}
                                />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                    <DetailsModal
                        campaign={""}
                        show={show}
                        mainTask={mainTask}
                        yes_percernt={getPercent(yes.length, _target)}
                        no_percernt={getPercent(no.length, _target)}
                        onHide={() => { }}
                        pos_resume={_pos_resume}
                        effycency={effycency}
                    />
                </Modal.Body>

            </Modal>

        </>
    )
}

function DetailsModal({
    pos_resume = [],
    show,
    onHide,
    no_percernt,
    yes_percernt,
    mainTask,
    setShow,
    campaign

}) {
    const [type, setType] = useState(null)
    const _cols = [
        {
            dataField: "count",
            text: "#",
            sort: true,
            headerStyle: {
                width: "50px",
            }
        },
        {
            dataField: "pos",
            text: "Location",
            sort: true,
            headerStyle: {
                minWidth: "100px",
            }
        },
        {
            dataField: "no",
            text: "no",
            sort: true,
            type: "no",
            headerStyle: {
                width: "70px",
            },
            events: {
                onClick: () => {
                    setType(type ? null : "no")
                }
            },
            headerEvents: {
                onClick: () => {
                    setType(type ? null : "no")
                }
            }

        },
        {
            dataField: "yes",
            text: "yes",
            sort: true,
            type: "yes",
            headerStyle: {
                width: "70px",
            },
            events: {
                onClick: () => {
                    setType(type ? null : "yes")
                }
            },
            headerEvents: {
                onClick: () => {
                    setType(type ? null : "yes")
                }
            }
        },
        {
            dataField: "total",
            text: "answers",
            sort: true,
            headerStyle: {
                width: "110px",
            }
        },
        {
            dataField: "percent_no",
            text: "No %",
            sort: true,
            type: "no",
            footer: no_percernt,
            headerStyle: {
                width: "90px",
            },
            events: {
                onClick: () => {
                    setType(type ? null : "no")
                }
            },
            headerEvents: {
                onClick: () => {
                    setType(type ? null : "no")
                }
            }
        },
        {
            dataField: "percent_yes",
            text: "yes %",
            sort: true,
            type: "yes",
            footer: yes_percernt,
            headerStyle: {
                width: "90px",
            },
            events: {
                onClick: () => {
                    setType(type ? null : "yes")
                }
            },
            headerEvents: {
                onClick: () => {
                    setType(type ? null : "yes")
                }
            }

        },
    ].filter(col => !col.type || type === col.type || !type)
    const totalizer_cols = ["no", "yes", "total", "percent_no", "percent_yes"]
    const money_cols = ["percent_no", "percent_yes"]
    const cols = _cols.map(col => {
        if (!totalizer_cols.includes(col.dataField)) {
            return { ...col, footer: "-" }
        }
        const total = pos_resume.reduce((acc, row) => acc + Number(row[col.dataField] ?? 1), 0)
        return {
            ...col,
            footer: col.footer ?? total,
            footerFormatter: money_cols.includes(col.dataField) ?
                priceFormatter : unitsFormatter
        }

    })

    return (
        <div show={show}

        >

        <hr/>
            <div className="w-100 d-flex justify-content-end">
                <ExcelExport columns={cols.map((col) => col.dataField)} data={pos_resume.map((doc, i) => ({ count: Number(i) + 1, ...doc }))} name="POS SUMMARY">
                    <div className="btn btn-success font-weight-bolder mx-2">
                        Export XLS
                    </div>
                </ExcelExport>
                <PDFExport
                    columns={cols.map((col) => col.dataField)}
                    data={pos_resume.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
                    name="POS SUMMARY"
                    sign={
                        campaign.name +
                        "\n" +
                        mainTask
                        +
                        "\n" +
                        moment(campaign.start_date).format("MMMM/DD/YY") +
                        "-" +
                        moment(campaign.end_date).format("MMMM/DD/YY")
                    }
                >
                    <button className="btn btn-danger font-weight-bolder mx-2">
                        Export PDF
                    </button>
                </PDFExport>
            </div>

            <div style={{ height: "500px", overflowY: "scroll" }}>
                <BootstrapTable
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    hover
                    striped
                    keyField="uid"
                    overlay={overlayFactory({ spinner: true })}
                    noDataIndication={
                        <div className="mr-2 text-muted">No records found</div>
                    }
                    data={pos_resume.map((doc, i) => ({
                        count: Number(i) + 1,
                        ...doc,
                    }))}
                    columns={cols}
                ></BootstrapTable>
            </div>


        </div>
    )
}
